import { GetCalendarResponse, GetCalendarBusyTimeSlot } from "@gettactic/api";
import { CalendarEvent } from "@cmp-src/calendar/CalendarDayView/types";
import { set, format, isWithinInterval } from "date-fns";
import { getRandomColor } from "@gettactic/helpers/src/colors";

const today = new Date();
export const formatTime = (h: number, m: number) =>
  format(
    set(today, { hours: h, minutes: m, seconds: 0, milliseconds: 0 }),
    "yyyy-MM-dd'T'HH:mm:ss"
  );

/**
 * Maps MyCalendar API response to CalendarEvent format
 * Following the mock data structure and comments
 */
export function mapMyCalendarToCalendarEvents(
  calendarData: GetCalendarResponse
): CalendarEvent[] {
  const events: CalendarEvent[] = [];

  Object.entries(calendarData.busy_times).forEach(([userId, busyTime]) => {
    const { user, slots } = busyTime;

    // If no slots are available, skip this user
    if (!slots || slots.length === 0) {
      return;
    }

    slots.forEach((slot) => {
      const isOngoing = getIsOngoing(slot);
      const event: CalendarEvent = {
        id: `int-slot-${userId}-${slot.start}-${slot.end}`,
        // Use meeting title from calendar or user name
        title: slot.subject || user.name,

        // userName: user.name,
        // picture: user.profile_photo_url,
        // email: user.email,

        startTime: convertToLocalTime(slot.start),
        endTime: convertToLocalTime(slot.end),
        location: getLocationFromSlot(slot),

        color: getDefaultColor(isOngoing),
        borderColor: user.name
          ? getRandomColor({ string: user.name || "" })
          : getDefaultBorderColor(isOngoing),
        category: getDefaultCategory(),

        textColor: getTextColor(isOngoing)
      };

      events.push(event);
    });
  });

  return events;
}

function getIsOngoing(slot: GetCalendarBusyTimeSlot): boolean {
  const slotStart = new Date(slot.start.replace(":00Z", ""));
  const slotEnd = new Date(slot.end.replace(":00Z", ""));
  return isWithinInterval(new Date(), { start: slotStart, end: slotEnd });
}

/**
 * Get location from slot - for now just use the source as location
 */
function getLocationFromSlot(slot: GetCalendarBusyTimeSlot): string {
  return slot.source || "Calendar Event";
}

/**
 * Get default color - only "default" available as per mock comments
 */
function getDefaultColor(isOngoing: boolean): string {
  return isOngoing ? "#656CFF" : "#ffffff";
}

/**
 * Get default border color - only "default" available as per mock comments
 */
function getDefaultBorderColor(isOngoing: boolean): string {
  return isOngoing ? "#4239E0" : "#0090FF";
}

function getTextColor(isOngoing: boolean): string | undefined {
  return isOngoing ? "#ffffff" : undefined;
}

/**
 * Get default category - only "Reservation" available as per mock comments
 */
function getDefaultCategory(): string {
  return "Reservation";
}

/**
 * Convert UTC time string to local time string
 * The calendar component expects local time, but API returns UTC
 */
function convertToLocalTime(utcTimeString: string): string {
  const dateString = utcTimeString.replace(":00Z", "");
  return dateString;
}
